import { graphql } from '@/api/graphql/codegen';

export const GetSeminarQueryDocument = graphql(/* GraphQL */ `
  query GetSeminar($seminarInput: GetSeminarsInput!) {
    seminars(seminarsInput: $seminarInput) {
      id
      identifier
      name
      date
      endDate
      lector
      accreditation
      city
      duration
      price
      deposit
      theoryDuration
      practiceDuration
      capacity
      substituteCapacity
      type
      participants {
        id
        name
        dateOfBirth
        paymentMethod
        email
        phone
        school
        ico
        invoiceEmail
        note
        address
        placeOfBirth
        createdAt
        updatedAt
        wantsAllowance
        fileUrls
        education
        branchOffice
        isSubstitute
      }
      author {
        firstName
        lastName
        degree
        email
        address
        phone
      }
    }
  }
`);
